import { render } from "./Step-3.vue?vue&type=template&id=28043724"
import script from "./Step-3.vue?vue&type=script&lang=js"
export * from "./Step-3.vue?vue&type=script&lang=js"

import "./Step-3.vue?vue&type=style&index=0&id=28043724&lang=scss"

import exportComponent from "/Users/billyhan/Sites/sol-v3/web/wp-content/themes/swinburne/assets/Eligibility/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__